import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// Use dynamic backend URL or fallback to env variable
const BACKEND_URL = window.APP_CONFIG?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Get session_id from hash or sessionStorage (fallback for redirect scenarios)
      let sessionId = null;
      const hash = window.location.hash;
      
      if (hash) {
        const params = new URLSearchParams(hash.substring(1));
        sessionId = params.get('session_id');
      }
      
      // Fallback to sessionStorage (set by index.js before any redirects)
      if (!sessionId) {
        sessionId = sessionStorage.getItem('pending_session_id');
        console.log('Using sessionStorage fallback for session_id');
      }
      
      // Clear the pending session
      sessionStorage.removeItem('pending_session_id');

      if (!sessionId) {
        console.error('No session_id found in hash or sessionStorage');
        navigate('/login', { replace: true });
        return;
      }
      
      console.log('Processing auth callback with session_id');

      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const user = response.data;
        
        // Get session token from response header
        const sessionToken = response.headers['x-session-token'] || response.headers['X-Session-Token'];
        
        if (sessionToken) {
          // Store in localStorage as PRIMARY method
          localStorage.setItem('session_token', sessionToken);
          localStorage.setItem('user', JSON.stringify(user));
        }
        
        // Navigate immediately with user data
        navigate('/jobs', { replace: true, state: { user, fromAuth: true } });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { replace: true, state: { fromAuth: true } });
      }
    };

    processSession();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-zinc-200 border-t-[#207024] mx-auto"></div>
        <p className="mt-4 font-inter text-zinc-600">Signing you in...</p>
      </div>
    </div>
  );
}